module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/triangle-arrow-ee5c9e889def35e6e8184b11f659a5ed.svg&quot;;"